<template>
  <div>
    <ClientOnly>
        <NuxtLoadingIndicator   color="#9152f7" />
      </ClientOnly>
    <Header/>
    <main role="main" class="main">
        <slot />
    </main>
    <Footer/>
  </div>
</template>
